export default "__VITE_ASSET__CaVWFJ1E__"